import React, { lazy, Suspense, useMemo } from "react"
import ImageComponent from "../../micro-component/Image"
import { ImageWrapperProps } from "./ImageWrapper.types"
import { getAspectRatio } from "@common/utils/cssUtils"

const ImageByName = lazy(() => import("./ImageByName"))
const ImageByNameAndColor = lazy(() => import("./ImageByNameAndColor"))
let _imageWrapperGlobalPrefix: string | undefined = undefined

export const getImageComponent = (name: string, color: string, width?: number, height?: number): React.ReactElement => {
  return <ImageByNameAndColor name={name} color={color} width={width} height={height} />
}

export const setImageWrapperGlobalPrefix = (prefix: string | undefined) => {
  _imageWrapperGlobalPrefix = prefix
}

const ImageWrapper = ({
  url,
  name,
  width,
  height,
  alt_text = "",
  loading = "lazy",
  className = "",
  style = {},
  testId = "shownImage",
  onClick = () => {},
  color,
  parentclassName = "",
  prefix,
}: ImageWrapperProps) => {
  const aspectRatio = useMemo(() => getAspectRatio(url), [url])
  const imageStyle = { ...style, ...(aspectRatio ? { aspectRatio } : {}) }

  const renderFallbackLoader = () => {
    return <div className={className} style={{ width: width || 24, height: height || 24, ...(imageStyle || {}) }} />
  }

  if (name && color) {
    return <Suspense fallback={renderFallbackLoader()}>{getImageComponent(name, color, width, height)}</Suspense>
  }

  if (name !== null && name !== undefined && name.length > 0) {
    return (
      <div className={parentclassName}>
        <Suspense fallback={renderFallbackLoader()}>
          <ImageByName
            name={name}
            alt_text={alt_text || name}
            style={imageStyle}
            width={width}
            height={height}
            className={className}
            loading={loading}
            data-testid={testId}
            onClick={onClick}
          />
        </Suspense>
      </div>
    )
  }

  const finalUrl = typeof url == "string" ? (prefix ?? _imageWrapperGlobalPrefix ?? "") + url : url

  return (
    <div className={parentclassName}>
      <ImageComponent
        src={finalUrl}
        alt={alt_text ?? name}
        width={width}
        style={imageStyle}
        height={height}
        className={className}
        loading={loading}
        testId={testId}
        onClick={onClick}
      />
    </div>
  )
}

export default ImageWrapper
